import Tr from 'translations/Translations'

export const getUserFullNameWithEmailAndDeputy = (apiUser) => {
    let name = getUserFullNameWithEmail(apiUser);
    if (apiUser?.replacedUser) {
        name += Tr('in_deputy_of') + apiUser.replacedUser.firstName + " " + apiUser.replacedUser.lastName;
    }
    return name;
}
export const getUserFullNameWithDeputy = (apiUser) => {
    let name = getUserFullName(apiUser);
    if (apiUser?.replacedUser) {
        name += Tr('in_deputy_of') + apiUser.replacedUser.firstName + " " + apiUser.replacedUser.lastName;
    }
    return name;
}

export const getUserFullNameWithEmail = (apiUser) => {
    let name = getUserFullName(apiUser);
    if (apiUser && apiUser.email) {
        name += " (" + apiUser.email + ")";
    }
    return name;
}
export const getUserFullName = (apiUser) => {
    let name = '';
    if (apiUser) {
        name += apiUser.firstName + " " + apiUser.lastName;
    }
    return name;
}

